import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ProductProvider } from './Context/ProductContext'
import { AuthProvider } from './Context/AuthContext'
import { ModalProvider } from './Context/ModalContext'
import { BrowserRouter as Router } from 'react-router-dom'
import { StrictMode } from 'react';

ReactDOM.render(
  <StrictMode>
    <ModalProvider>
      <AuthProvider>
        <ProductProvider>
          <Router>
            <App />
          </Router>
        </ProductProvider>
      </AuthProvider>
    </ModalProvider>
  </StrictMode>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();